import JobsByCityContent from "../components/JobsByCitiesContent";
import Layout from "../components/Layout";
import jobsByCities from "../services/jobsByCities";
import { useEffect } from "react";

export async function getServerSideProps(ctx) {
  let cityData = {};
  try {
    const res = await jobsByCities.getJobsByCities({});
    cityData = res.data;
  } catch (error) {
    cityData = {};
  }
  return { props: { cityData } };
}

const JobsByCity = props => {
  const { cityData = {} } = props;
  const { data = [] } = cityData;
  useEffect(() => {
    console.log("LIVE_URL_HIRE", process.env.LIVE_URL_HIRE);
  }, []);
  return (
    <>
      <Layout
        showTabs={false}
        showHeader={true}
        isAuthNavigationEnabled={false}
        showFooter={true}
        contentClass={"jobsByCities"}
        title="Hire candidates across 400+ cities in India"
        metaDescription="Recruit relevant candidates from different cities in India as per your requirement"
        canonical={`${process.env.LIVE_URL_HIRE}/jobs-by-cities`}
      >
        <JobsByCityContent sitemapPageData={[data]} />
      </Layout>
    </>
  );
};

export default JobsByCity;
